var render = function render(){
  var _vm$global$profile, _vm$global$profile2;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.designId ? _c('dialog-scroll-lock-loader', _vm._g(_vm._b({
    attrs: {
      "width": "960",
      "content-class": "fill-height grey lighten-5 overflow-auto d-flex flex-column relative",
      "loading": _vm.loadStatus.pending,
      "fullscreen": _vm.$vuetify.breakpoint.xsOnly,
      "value": true
    }
  }, 'dialog-scroll-lock-loader', _vm.$attrs, false), _vm.$listeners), [_c('error-dialog', {
    attrs: {
      "status": _vm.loadStatus
    }
  }), _c('error-dialog', {
    attrs: {
      "status": _vm.createStatus
    }
  }), _c('div', {
    staticClass: "d-flex pa-3"
  }, [_c('v-btn', {
    staticClass: "px-2",
    attrs: {
      "text": "",
      "color": "primary",
      "disabled": _vm.getOrgSkinStatus.pending,
      "loading": _vm.createStatus.pending
    },
    on: {
      "click": _vm.create
    }
  }, [_c('v-icon', {
    staticClass: "mr-2",
    domProps: {
      "innerHTML": _vm._s(_vm.mdiPencil)
    }
  }), _vm._v(" Use this design "), _c('v-icon', {
    staticClass: "ml-2",
    domProps: {
      "innerHTML": _vm._s(_vm.mdiChevronRight)
    }
  })], 1), _c('v-spacer'), _vm.design ? [(_vm$global$profile = _vm.global.profile) !== null && _vm$global$profile !== void 0 && _vm$global$profile.org_admin ? _c('design-org-admin-btn', {
    attrs: {
      "scope": "card",
      "target-id": _vm.designId
    }
  }) : (_vm$global$profile2 = _vm.global.profile) !== null && _vm$global$profile2 !== void 0 && _vm$global$profile2.admin ? _c('design-admin-btn', {
    attrs: {
      "design-id": _vm.designId
    }
  }) : _vm._e()] : _vm._e(), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('input', false);
      }
    }
  }, [_c('v-icon', {
    domProps: {
      "innerHTML": _vm._s(_vm.mdiClose)
    }
  })], 1)], 2), _c('v-divider'), !_vm.loadStatus.pending ? _c('div', {
    staticClass: "flex-grow-1 relative"
  }, [_vm.design ? [_c('v-row', {
    staticClass: "ma-0"
  }, [_c('v-col', {
    staticClass: "pa-6 mx-auto overflow-hidden",
    attrs: {
      "cols": "8",
      "sm": "5",
      "md": "6"
    }
  }, [_c('v-responsive', {
    staticClass: "mx-auto overflow-visible",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "aspect-ratio": 3 / 4
    }
  }, [_c('envelope-order-preview', {
    staticClass: "fill-height",
    attrs: {
      "order": _vm.preview
    },
    on: {
      "click": function () {
        return _vm.getOrgSkinStatus.pending || _vm.create();
      }
    }
  })], 1)], 1), _c('v-col', {
    staticClass: "pa-6 pt-3 pt-sm-6",
    attrs: {
      "cols": "12",
      "sm": "7",
      "md": "6"
    }
  }, [_c('div', {
    staticClass: "d-flex align-center"
  }, [_c('v-icon', {
    attrs: {
      "color": "ec-dark-blue"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.iconPathCardUnknownType)
    }
  }), _c('div', {
    staticClass: "ml-2 ec-dark-blue--text title",
    staticStyle: {
      "line-height": "1.2em"
    }
  }, [_vm._v("What type of card do you want to send?")])], 1), _c('v-radio-group', {
    staticClass: "pl-8",
    attrs: {
      "hide-details": "",
      "value": _vm.type
    },
    on: {
      "change": function (v) {
        return _vm.type = v;
      }
    }
  }, [_c('v-radio', {
    staticClass: "mb-9",
    attrs: {
      "label": "Personal card",
      "value": "PERSONAL"
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function () {
        return [_c('div', {
          staticClass: "mr-6"
        }, [_c('div', [_vm._v("Personal card")]), _c('div', {
          staticClass: "text--label-active"
        }, [_vm._v("Signed by you only")])]), _c('v-spacer'), _c('v-icon', {
          domProps: {
            "innerHTML": _vm._s(_vm.iconPathCardPersonal)
          }
        })];
      },
      proxy: true
    }], null, false, 1362717890)
  }), _c('v-radio', {
    staticClass: "mb-9",
    attrs: {
      "label": "Group card",
      "value": "GROUP"
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function () {
        return [_c('div', {
          staticClass: "mr-6"
        }, [_c('div', [_vm._v("Group card")]), _c('div', {
          staticClass: "text--label-active"
        }, [_vm._v("Invite contributors to sign")])]), _c('v-spacer'), _c('v-icon', {
          domProps: {
            "innerHTML": _vm._s(_vm.iconPathCardGroup)
          }
        })];
      },
      proxy: true
    }], null, false, 3718689085)
  }), _c('v-radio', {
    attrs: {
      "label": "Event invitation",
      "value": "INVITATION"
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function () {
        return [_c('div', {
          staticClass: "mr-6"
        }, [_c('div', [_vm._v("Event invitation")]), _c('div', {
          staticClass: "text--label-active"
        }, [_vm._v("Includes RSVPs")])]), _c('v-spacer'), _c('v-icon', {
          domProps: {
            "innerHTML": _vm._s(_vm.iconPathCardInvitation)
          }
        })];
      },
      proxy: true
    }], null, false, 3829566207)
  })], 1), _c('div', {
    staticClass: "mt-10 mt-sm-16 d-flex justify-center justify-sm-start"
  }, [_c('v-btn', {
    attrs: {
      "color": "primary",
      "loading": _vm.createStatus.pending,
      "disabled": _vm.getOrgSkinStatus.pending
    },
    on: {
      "click": _vm.create
    }
  }, [_c('v-icon', {
    staticClass: "mr-2",
    domProps: {
      "innerHTML": _vm._s(_vm.mdiPencil)
    }
  }), _vm._v(" Use this design "), _c('v-icon', {
    staticClass: "ml-2",
    domProps: {
      "innerHTML": _vm._s(_vm.mdiChevronRight)
    }
  })], 1)], 1), _vm.$vuetify.breakpoint.mdAndUp && (_vm.design.top_tags || []).length ? _c('div', {
    staticClass: "mt-16 pt-0 pt-sm-8 pt-lg-16 overflow-hidden"
  }, [_c('div', {
    staticClass: "text--label-active grey--text"
  }, [_vm._v("Find similar cards")]), _c('div', {
    staticClass: "mx-n2"
  }, _vm._l(_vm.design.top_tags, function (tag) {
    return !['invitation', 'greeting card'].includes(tag.toLowerCase()) ? _c('v-btn', {
      key: tag,
      staticClass: "ma-2",
      attrs: {
        "outlined": "",
        "small": "",
        "rounded": "",
        "dark": "",
        "color": "primary",
        "exact": "",
        "to": {
          params: {
            selectedId: undefined
          },
          query: Object.assign({}, _vm.$route.query, {
            q: tag
          })
        }
      },
      domProps: {
        "innerHTML": _vm._s(tag)
      }
    }) : _vm._e();
  }), 1)]) : _vm._e()], 1)], 1), _c('v-divider', {
    staticClass: "mt-6"
  }), _c('div', {
    staticClass: "grey lighten-3 pb-3"
  }, [_c('catalog-design-details', {
    staticClass: "pa-6",
    attrs: {
      "design-id": _vm.designId,
      "design": _vm.design
    }
  }), _vm.$vuetify.breakpoint.smAndDown ? _c('div', {
    staticClass: "px-6 mt-n2 mb-6 overflow-hidden"
  }, [(_vm.design.top_tags || []).length ? [_c('div', {
    staticClass: "mt-6 text--label-active grey--text"
  }, [_vm._v("Find similar cards")]), _c('div', {
    staticClass: "mx-n2"
  }, _vm._l(_vm.design.top_tags, function (tag) {
    return _c('v-btn', {
      key: tag,
      staticClass: "ma-2",
      attrs: {
        "outlined": "",
        "small": "",
        "rounded": "",
        "dark": "",
        "color": "primary",
        "exact": "",
        "to": {
          params: {
            selectedId: undefined
          },
          query: Object.assign({}, _vm.$route.query, {
            q: tag
          })
        }
      },
      domProps: {
        "innerHTML": _vm._s(tag)
      }
    });
  }), 1)] : _vm._e()], 2) : _vm._e(), _c('div', {
    staticClass: "px-6 text--label-active grey--text mb-2"
  }, [_vm._v("Customize the theme – add backgrounds, confetti, music, stamps, fonts, colors, and more")]), _c('div', {
    staticClass: "d-flex pb-3 px-6",
    staticStyle: {
      "margin-left": "-12%"
    }
  }, [_c('outline-laptop', {
    staticStyle: {
      "width": "81.5%"
    }
  }, [_c('v-lazy', [_c('skin-preview', {
    staticClass: "absolute-fill",
    attrs: {
      "from": "Example sender",
      "to": "Example recipient",
      "mode": "preview",
      "skin": _vm.skin,
      "card": _vm.preview
    },
    nativeOn: {
      "click": function ($event) {
        return _vm.create.apply(null, arguments);
      }
    }
  })], 1)], 1), _c('outline-phone', {
    staticStyle: {
      "width": "18.5%"
    },
    attrs: {
      "vertical": ""
    }
  }, [_c('v-lazy', [_c('skin-preview', {
    staticClass: "absolute-fill",
    attrs: {
      "from": "Example sender",
      "to": "Example recipient",
      "mode": "preview",
      "skin": _vm.skin,
      "card": _vm.preview
    },
    nativeOn: {
      "click": function ($event) {
        return _vm.create.apply(null, arguments);
      }
    }
  })], 1)], 1)], 1)], 1), _c('v-divider'), _c('div', {
    staticClass: "pa-3"
  }, [_c('v-btn', {
    attrs: {
      "text": "",
      "color": "primary",
      "disabled": _vm.getOrgSkinStatus.pending,
      "loading": _vm.createStatus.pending
    },
    on: {
      "click": _vm.create
    }
  }, [_c('v-icon', {
    staticClass: "mr-2",
    domProps: {
      "innerHTML": _vm._s(_vm.mdiPencil)
    }
  }), _vm._v(" Use this design "), _c('v-icon', {
    staticClass: "ml-2",
    domProps: {
      "innerHTML": _vm._s(_vm.mdiChevronRight)
    }
  })], 1)], 1)] : _vm._e()], 2) : _vm._e()], 1) : _vm._e();

}
var staticRenderFns = []

export { render, staticRenderFns }